import { useParams } from "react-router-dom";
import firebase from '../data/firebase'
import { getDatabase, ref, set, get } from "firebase/database";
import { useState, useEffect } from 'react'
import { useMemo } from "react";
import { Image } from 'antd';

function CanvasItem() {
    
    const [exists, setExists] = useState(false)
    const [canvasData, setCanvasData] = useState({ "settings": null, "original": null, "nftaddress": null, "output": null})
    let { canvasID } = useParams();
    useEffect( () =>{
        if(parseInt(canvasID) < 51){
            get(ref(firebase, 'canvashistory/' + canvasID)).then((DataSnapshot) => {
                if(DataSnapshot.size > 0 ){
                    let dataArray = { "settings": null, "original": null, "nftaddress": null, "output": null};
                    DataSnapshot.forEach(element => {
                        var key = element.key;
                        var data = element.val();
                        dataArray[key] = data;
                    });
                    setCanvasData(dataArray)
                    setExists(true)
                }
            })
        } else {
            setCanvasData({ "settings": null, "original": null, "nftaddress": null, "output": null})
            setExists(false)
        }
    }, [])

    return (
        <>
            <div style={{marginTop: "2.5em"}}className="container flex-center text-white">
                <h1>0xDRIP - Canvas #{canvasID}</h1>
            </div>
            
            <div className="flex-center-column text-center text-white container">
                {}
                { exists ? <> 
                <p>Settings: {canvasData?.settings}</p>
                { canvasData?.original !== "null" ? 
                    <>
                        <Image className="canvas-preview" src={canvasData?.original} 
                        
                            placeholder={
                                <Image
                                preview={false}
                                src="/loading_box.jpg"
                                />
                            }
                        />
                    {" ---> "}
                    </>
                : <>Original not found sorry! </>}
                <Image className="canvas-preview" src={canvasData?.output} 
                        
                    placeholder={
                        <Image
                        preview={false}
                        src="/loading_box.jpg"
                        />
                    }
                />
                
                </>: <> { parseInt(canvasID) > 51 ? <>There are only 50 canvas in the collection! </> : <>This one hasn't been DRIPPED yet!</>} </>}
            </div>
        </>
    )
}

export default CanvasItem